import React, { useContext, useEffect, useState } from 'react';
import EnhancedTable from '../components/EnhancedTable';
import apiFetch from '../utils/apiUtils';
import { ErrorContext } from "../utils/constants";

import { makeStyles } from "@material-ui/core/styles";
import Colors from "../utils/colors";
import Button from "@material-ui/core/Button";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';

import moment from "moment";
import MomentUtils from "@date-io/moment";

const useStyles = makeStyles(() => ({

  editorDiv: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: '2rem',
  },

  editorContainer: {
    backgroundColor: Colors.lightBlue,
    width: '63%'
  },

  rowLabel: {
    marginLeft: '1rem',
  },

  rowDiv: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '1rem',
  },

  rowMessage: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '0px',
  },

  'inline': {
    width: '10%',
    marginLeft: '0',
  },

  datepicker: {
    backgroundColor: 'white'
  }

}));

const changeTrackerHeadCells = [
  { id: 'initiative_id', numeric: false, disablePadding: false, label: 'Initiative Id' },
  { id: 'initiative_name', numeric: false, disablePadding: false, label: 'Initiative Name' },
  { id: 'modifiedField', numeric: false, disablePadding: true, label: 'Modified Field' },
  { id: 'old_value', numeric: false, disablePadding: true, label: 'Old Value' },
  { id: 'new_value', numeric: false, disablePadding: true, label: 'New Value' },
  { id: 'modified_date', numeric: false, disablePadding: true, label: 'Modified Date', format: 'date' },
];

export default function ReviewerView() {

  const classes = useStyles();

  const [ changeTrackers, setChangeTrackers ] = useState([]);

  const [modifiedInitiatives, setModifiedInitiatives] = useState([]);
  const { triggerError } = useContext(ErrorContext);
  const dateFormat = 'MM-DD-YYYY';

  const formatDate = (date) => {
    if (date) {
      return moment(date).format(dateFormat);
    }
    return '';
  };

  const [startDate, setStartDate] = useState(moment(new Date()).subtract(30, 'day'));
  const [endDate, setEndDate] = useState(new Date());

  const dateRange = {
    startDate: startDate,
    endDate: endDate,
  };

  useEffect(() => {
    document.title = 'Rise by TransAlta Change Tracker Dashboard';
  }, []);

  const handleSubmitBtn = () => {
    apiFetch('/dashboards/changetracker', 'POST', JSON.stringify(dateRange),
      data => {
        setModifiedInitiatives(data);
        setChangeTrackers(data);
      },
      (error) => {
        triggerError({
          title: 'Communication Error',
          description: 'We were unable to read your current and previous reviews data from the server. Please try again.',
          onRetry: () => window.location.reload(),
        });
      });
  }

  return (
    <main>
      <h2>Select a date range to display the list of initiatives that have been modified</h2>
      <div className={classes.editorDiv}>
        <div className={classes.editorContainer}>
          <div className={classes.rowLabel}>
            <h4>Initiative Date Range</h4>
          </div>
          <div className={classes.rowDiv}>
            <MuiPickersUtilsProvider utils={MomentUtils} style={{ marginTop: '5rem' }} >
              <KeyboardDatePicker
                clearable
                value={startDate}
                placeholder="10/10/2018"
                inputVariant="outlined"
                label="Start Date"
                onChange={date => setStartDate(formatDate(date))}
                format="YYYY/MM/DD"
                className={classes.datepicker}
              />
              <KeyboardDatePicker
                clearable
                value={endDate}
                placeholder="10/10/2018"
                inputVariant="outlined"
                label="End Date"
                onChange={date => setEndDate(formatDate(date))}
                format="YYYY/MM/DD"
                className={classes.datepicker}
              />
            </MuiPickersUtilsProvider>
            <Button
              className={classes.inline}
              onClick={handleSubmitBtn}
              variant="contained"
              color="primary"
              disabled={((((new Date(endDate)).getTime() - (new Date(startDate)).getTime()) / (1000 * 3600 * 24)) > 31) ? true : false}
            >
              SUBMIT
            </Button>
          </div>

        </div>

      </div>
      <div className={classes.rowMessage}>* Maximum date range is 31 days</div>
      {
        modifiedInitiatives.length !== 0 ? <div>
          <h2>Modified Initiatives</h2>
          Here are the initiatives that have been modified within the selected date range:
          <EnhancedTable 
            id='ba0978a9-c68d-4db6-9551-1f30982dcc2b'
            rows={changeTrackers}
            headCells={changeTrackerHeadCells}
            rows={modifiedInitiatives}
            allowExport={true}
            exportFilename='Change Tracker'
            clickData={{ url: '/ui/initiativecard/', key: 'initiative_id' }} />
          <p />
        </div>
          :
          <div></div>
      }

    </main>
  );
}
